import { useParams } from "react-router-dom";
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getUrl } from '../../App';
import VideoTeamInfo from "../VideoTeamInfo/VideoTeamInfo";
import styles from './VideoView.module.css';
import AnnotatedVideo from "../AnnotatedVideo/AnnotatedVideo";

const fetch_video = async (id) => {
    const response = await fetch(`${getUrl()}/api/videos/?game=${id}`, { credentials: 'include', });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}
const fetch_game = async (id) => {
    const response = await fetch(`${getUrl()}/api/games/${id}`, { credentials: 'include', });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}

function VideoView() {

    const { id } = useParams();

    const [isSwapped, setIsSwapped] = useState(false);

    const video = useQuery({
        queryKey: ['video', id], queryFn: () => fetch_video(id),
        staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
        cacheTime: 5 * 60 * 1000,
    });

    const game = useQuery({
        queryKey: ['game', id], queryFn: () => fetch_game(id),
        staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
        cacheTime: 5 * 60 * 1000,
    });

    const [selectedVideo, setSelectedVideo] = useState(null);

    useEffect(() => {
        if (!selectedVideo && video.data && video.data.length > 0) {
            setSelectedVideo(video.data[0]);
        }
    }, [video.data, selectedVideo]);

    const handleSelectLog = (video_url) => {
            if(video.video_url) {
            setSelectedVideo(video_url);
            return;
            }
           
    };

    if (video.isError) {
        return <div>Error fetching video: {video.error.message}</div>;
    }

    if (video.isLoading || game.isLoading) {
        return <div>Loading video</div>
    }

    const Team1 = (
        <VideoTeamInfo
            id={game.data.team1}
            BallTime="10"
            BallDistance="20"
            WalkedDistance="40"
            onSelectLog={handleSelectLog}
        />
    );
    const Team2 = (
        <VideoTeamInfo
            id={game.data.team2}
            BallTime="9"
            BallDistance="10"
            WalkedDistance="35"
            onSelectLog={handleSelectLog}
        />
    );


    return (
        <div className={styles.view_content}>

            <div className="panel-header">
                <h3>Video View</h3>
            </div>
            <div className={styles.projects_section}>
                <div className={`${styles.jsGridView}`}>
                    <div className={styles.switch}>
                        <button onClick={() => setIsSwapped(!isSwapped)}>
                            Switch Team Stats
                        </button>
                    </div>
                    {isSwapped ? Team2 : Team1}
                    <div className={styles.video}>
                        {selectedVideo && <AnnotatedVideo className={`${styles.video}`} video={selectedVideo} />}
                    </div>
                    {isSwapped ? Team1 : Team2}
                    <div className={`${styles.footer}`}>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VideoView;